export default __webpack_public_path__ + "static/media/Scholar's Belt of the Crescent.9870ccc7.jpg";